import { injectCpmsBoChannelApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-channel.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoChannelApi = injectCpmsBoChannelApi(baseApi);

export const { useCpmsBoGetChannelsPaginatedQuery } = cpmsBoChannelApi;
